import React from "react";
import {
  Network,
  Presentation,
  Flame,
  Megaphone,
  Wrench,
  Fingerprint,
  Camera,
  Coffee,
  GraduationCap,
  UserCheck,
  Car,
  Shield,
} from "lucide-react";

const map = {
  Network,
  Presentation,
  Flame,
  Megaphone,
  Wrench,
  Fingerprint,
  Camera,
  Coffee,
  GraduationCap,
  UserCheck,
  Car,
  Shield,
};

export default function ServiceIcon({ name, className = "h-6 w-6" }) {
  const Icon = map[name] || Network;
  return <Icon className={className} />;
}
